var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66659 14.6668H2.66659C2.31296 14.6668 1.97382 14.5264 1.72378 14.2763C1.47373 14.0263 1.33325 13.6871 1.33325 13.3335V8.66683C1.33325 8.31321 1.47373 7.97407 1.72378 7.72402C1.97382 7.47397 2.31296 7.3335 2.66659 7.3335H4.66659M9.33325 6.00016V3.3335C9.33325 2.80306 9.12254 2.29436 8.74747 1.91928C8.37239 1.54421 7.86369 1.3335 7.33325 1.3335L4.66659 7.3335V14.6668H12.1866C12.5081 14.6705 12.8202 14.5578 13.0652 14.3495C13.3102 14.1412 13.4717 13.8514 13.5199 13.5335L14.4399 7.5335C14.4689 7.3424 14.456 7.14728 14.4021 6.96166C14.3483 6.77604 14.2547 6.60436 14.1278 6.45851C14.001 6.31265 13.844 6.19612 13.6676 6.11697C13.4913 6.03783 13.2999 5.99797 13.1066 6.00016H9.33325Z",
    stroke: "#373F41",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLike);
export default __webpack_public_path__ + "static/media/IconLike.c883809fa9b2a2dfe5d3337f3ad90310.svg";
export { ForwardRef as ReactComponent };